export default [
  // {
  //   path: '/workbench',
  //   name: 'workbench',
  //   meta: {
  //     title: '工作台',
  //     code: 'wecom|workbench'
  //   },
  //   component: () => import('@/pages/workbench/index')
  // },
 
]
